import config from 'config';
import * as types from '../actions/ticket-actions';

const initialState = {
	ticketTypes: []
};

const formatDate = function (date) {
	const intl = new Intl.DateTimeFormat('pt-BR', {
		year: 'numeric',
		month: 'numeric',
		day: 'numeric'
	});
	return intl.format(date);
};

const feedPeriodByType = function (game) {
	let periods = {};
	let ticketTypes = [];
	let periodExists = false;
	let ticketsArr = game.monthlyTickets; //game.weeklyTickets.concat(game.trimestrialTickets);

	// Loop all tickets
	for (let ticket of ticketsArr) {

		// Convert Date UTC
		const validityStartUTC = new Date(ticket.validityStart.split(' ')[0]);
		const validityEndUTC = new Date(ticket.validityEnd.split(' ')[0]);
		const lotteryDayUTC = new Date(ticket.lotteryDay.split(' ')[0]);

		// Convert DateTime (DD/MM/YYYY HH:MM:SS) to Date (DD/MM/YYYY)
		let validityStart = formatDate(validityStartUTC);
		let validityEnd = formatDate(validityEndUTC);
		let lotteryDay = formatDate(lotteryDayUTC);

		if (!periods[ticket.type]) {
			ticketTypes.push(ticket.type);
			periods[ticket.type] = [];
		}

		// Checks if this periods of lottery already exists
		if (periods[ticket.type]) {
			periodExists = false;
			for (let period of periods[ticket.type]) {
				if ((period.dates.validityStart === validityStart) &&
					(period.dates.validityEnd === validityEnd) &&
					(period.dates.lotteryDay === lotteryDay)) {
					periodExists = true;
					period.count++;

					let origin = (config.application.ticketOrigins.indexOf(ticket.origin) !== -1) ?
						ticket.origin :
						'JM';

					if (!period.tickets[origin]) period.tickets[origin] = [];
					if (!period.countOrigin[origin]) period.countOrigin[origin] = 0;
					period.countOrigin[origin]++;
					period.tickets[origin].push(ticket);
				}
			}

			// Add a new period of lottery of not exists
			if (!periodExists) {

				let origin = (config.application.ticketOrigins.indexOf(ticket.origin) != -1) ?
					ticket.origin :
					'JM';

				let date = lotteryDay.split('/');
				periods[ticket.type].push({
					msTime: new Date(date[2], date[1] - 1, date[0]).getTime(),
					dates: {
						validityStart,
						validityEnd,
						lotteryDay
					},
					count: 1,
					countOrigin: {
						[origin]: 1
					},
					tickets: {
						[origin]: [ticket]
					},
					type: ticket.type
				});
			}
		}
	}

	return { ticketTypes, periods };
};

const ticketReducer = function (state = initialState, action) {

	switch (action.type) {
		case types.RESET_TICKET:
			return Object.assign({}, state, initialState);
			break;

		case types.UPDATE_TICKET_LIST:

			let tickets = feedPeriodByType(action.game);

			return Object.assign({}, state, tickets);
			break;
	}

	return state;
};

export default ticketReducer;


// WEBPACK FOOTER //
// ./src/reducers/ticket-reducer.js